<template>
  <input class="min-h-[25px] rounded bg-inherit" type="text" />
</template>

<script>
  export default {
    name: "VInputText",
  };
</script>
